import { useEffect } from "react";
import { useAuth } from "@shared/contexts/auth-context";
import { useTranscriptionWebSocket } from "@shared/hooks/useTranscriptionWebSocket";

/**
 * Провайдер для WebSocket подключения транскрипций
 * Автоматически подключается когда пользователь авторизован
 */
// eslint-disable-next-line react/prop-types
export const TranscriptionWebSocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { connect, disconnect } = useTranscriptionWebSocket();

  useEffect(() => {
    if (isAuthenticated) {
      // Подключаемся к WebSocket когда пользователь авторизован
      connect();
    } else {
      // Отключаемся когда пользователь вышел
      disconnect();
    }
  }, [isAuthenticated, connect, disconnect]);

  return <>{children}</>;
};
